/* eslint-disable no-undef */
import React from "react";
import ProductSvg from '../public/myproducts.svg';
import EventsSvg from '../public/totalevents.svg';
import { showLoading } from 'react-global-loading';
import DashboardService from '../services/DashboardService';
import Modal from 'react-modal';
import moment from "moment";
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class SearchResult extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expandSidebar: false,
      eventData: [], searchResults: [],
      // searchQuery: props.match.params.query,
      productsData: [],
      filteredEvents: [],
      filteredProducts: [],
      docsData: [],
      users: [],
      schemes: [],
      eventPending: '',
      docApproved: '',
      docPending: '',
      eventApproved: '',
      productApproved: '',
      productPending: '',
      practitioner: [], page: 1, statusType: 1, showModal: false, modalData: {}
    };
  }

  componentDidMount = () => {

    this.onSearch(this.props.match.params.query);

  };
  componentWillReceiveProps(newProps) {
    if (this.props.match.params.query !== newProps.match.params.query) {
      this.onSearch(newProps.match.params.query)
    }
  }
  onSearch = (query) => {
    showLoading(true);
    DashboardService.getSearchResults(query)
      .then((result) => {
        if (!result) {
          return;
        }
        console.log("demo")
        this.setState({ searchResults: result.data })
        showLoading(false);
      })
      .catch((err) => {

        console.error(err);
      });
  }


  onNotiClick = (noti) => {

    switch (noti.type) {
      case 'event':
        this.props.history.push({

          pathname: "/mission-event-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'product':
        this.props.history.push({

          pathname: "/mission-products-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'document':
        this.setState({ showModal: true })
        // this.state.docsData.data.filter(item => item.ID === noti.post_id).map(selectedData => (
        this.setState({ modalData: noti })
        // ));
        break;
      case 'scheme':
        this.setState({ showModal: true, modalData: noti })
        break;

    }
  }
  render() {
    const { searchResults, schemes, practitioner, productsData, eventData, docsData, showModal, modalData } = this.state;

    return (
      <div className="container pt-2">
        <div className="row p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-12">
            <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active t1" id="notifications-tab" data-bs-toggle="tab" data-bs-target="#notifications-pane" type="button" role="tab" aria-controls="notifications-pane" aria-selected="true">Search Results...</button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="notifications-pane" role="tabpanel" aria-labelledby="notifications-pane" >
                <div className="row mt-4 m-ver-col">

                  {searchResults?.length > 0 ? searchResults?.map((item, index) => 
                  <div className="col-md-4 mb-3 m-db-card" key={index}>
                    <div className="card p-3 bg-secondary-subtle border-0 rounded rounded-4 mcard" onClick={() => this.onNotiClick(item)}>
                      <div className="row">
                        <div className="col-1">
                          <img src={item.post_type === 'products' && ProductSvg ||
                            item.post_type === 'events' && EventsSvg ||
                            item.post_type === 'documents' && ProductSvg ||
                            item.post_type === 'schemes' && ProductSvg
                          } className="float-end" alt="my events" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">{item.post_title}</h5>
                            <p className="card-text mb-2">
                              <small className="text-dark t4">{moment(item.post_date).format("Do MMM YYYY")}</small>
                            </p>
                            <p className="card-text t2">{item.post_content}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>) : < h3 > No data found</h3>}
                </div>
              </div>

            </div>
          </div>

          <Modal
            isOpen={showModal}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content bg-white p-3">
                <div className="modal-header">
                  <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">
                    {modalData.title}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showModal: false })}
                    // data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">

                  <div className="row mt-2 pdfht" aria-labelledby="#label1">
                    <object
                      id="#label1"
                      width="100%"
                      height="100%"
                      type="application/pdf"
                      data={modalData.document_upload}
                    />
                  </div>
                </div>
              </div>
            </div>

          </Modal>
        </div >
      </div>
    );
  }
}
export default SearchResult;